<template lang="pug">
  include ../../../views/desktop/shared/iconMixins.pug
  .address.xs-f-small.max-at-tweak.text-left
    .info-wrap(data-mr-ass="account-address-info")
      p {{ address.first_name }} {{ address.last_name }}
      p {{ address.street_1 }} {{ address.street_2 }}
      p {{ address.city }}, {{ address.region }} {{ address.post_code }}
      Pill(v-if='address.is_default_shipping && !hideDefault' text="default")

    .controls.pull-right
      button.btn-link.transparent-btn(v-if="edit" @click="editAddress(address)" data-mr-ass="account-edit-address")
        span.icon-edit
        span.ada-tooltip Edit Address

      button.btn-link.transparent-btn(v-if="remove" @click="deleteAddressModal(address)" data-mr-ass="account-delete-address")
        +icon-bin

</template>

<script>
  import { mapActions } from 'vuex';

  import Pill from '../Pill';

  export default {
    name: "Address",
    components: {
      Pill
    },

    props: {
      address: {
        type: Object,
        required: true
      },

      hideDefault: {
        type: Boolean,
        required: false,
        default: false
      },

      edit: {
        type: Boolean,
        required: false,
        default: false
      },

      remove: {
        type: Boolean,
        required: false,
        default: false
      },

      editMethod: {
        type: Function,
        required: false,
        default: null
      }
    },

    methods: {
      ...mapActions('addressBook', [
        'editAddressModal',
        'deleteAddressModal'
      ]),

      editAddress() {
        if (this.editMethod) {
          return this.editMethod(this.address);
        }

        this.editAddressModal(this.address);
      },
    }
  }
</script>

<style scoped lang="stylus">
  .info-wrap
    display inline-block

  .controls
    button
      padding 0 0.5em
</style>
